<template>
    <div id="tab">
        <div class="all_count">
            <span class="desc">共计</span>
            <span class="num">{{this.$store.state.allQuestions}}</span>
        </div>
        <div class="right">
            <span class="desc">正确</span>
            <span class="num">{{this.$store.state.rightAnswer}}</span>
        </div>
        <div class="vocabulary">
            <span class="desc">单词量</span>
            <div class="motion">
                <p>
                    {{myriabit}}{{kilobit}}{{hundreds}}{{decade}}{{unit}}
                </p>
            </div>
        </div>
        <div class="wrong">
            <span class="desc">错误</span>
            <span class="num">{{this.$store.state.wrongAnswer}}</span>
        </div>
        <div class="not_know">
            <span class="desc">不认识</span>
            <span class="num">{{this.$store.state.notKnow}}</span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'Tab',
        data() {
            return {
                unit: '0',
                decade: '',
                hundreds: '',
                kilobit: '',
                myriabit: ''
            };
        },
        computed:{
            ...mapGetters([
                'lastVocabulary'
            ])
        },
        watch: {
            lastVocabulary: function(val) { 
                this.changeNum(val)
                this.$store.commit('MOTIONNUM', val)
            }
        },
        methods: {
            changeNum: function (val) {
                let unit
                let decade
                let hundreds
                let kilobit
                let myriabit
                myriabit = Math.floor(val/10000)
                kilobit = Math.floor((val - 10000 * myriabit)/1000)
                hundreds = Math.floor((val - 10000 * myriabit - kilobit * 1000)/100)
                decade = Math.floor((val - 10000 * myriabit - kilobit * 1000 - hundreds * 100)/10)
                unit = Math.floor(val - 10000 * myriabit - kilobit * 1000 - hundreds * 100 - decade * 10)
                let motionNuml = this.$store.state.motionNum.toString().length
                let vall = val.toString().length
                if (vall > motionNuml || vall < motionNuml ) {
                    if (val < 10000) {
                        myriabit = ''
                    }
                    if (val < 1000) {
                        kilobit = ''
                    }
                    if (val < 100) {
                        hundreds = ''
                    }
                    if (val < 10) {
                        decade = ''
                    }
                    this.myriabit = myriabit
                    this.kilobit = kilobit
                    this.hundreds = hundreds
                    this.decade = decade
                    this.unit = unit
                } else {
                    if (val < 10000) {
                        myriabit = ''
                    }
                    if (val < 1000) {
                        kilobit = ''
                    }
                    if (val < 100) {
                        hundreds = ''
                    }
                    if (val < 10) {
                        decade = ''
                    }
                    if (val < 0) {
                        unit = '0'
                    }
                    this.motionUnit(unit)
                    this.motionDecade(decade)
                    this.motionHundreds(hundreds)
                    this.motionKilobit(kilobit)
                    this.motionMyriabit(myriabit)
                }
            },
            motionMyriabit: function (num) {
                let that = this
                let timerMyriabit
                if (num > that.myriabit) {
                    timerMyriabit = setInterval(() => {
                        that.myriabit ++
                        if (num == that.myriabit) {
                            clearInterval(timerMyriabit)
                        }
                    }, 100);
                } else if (num < that.myriabit){
                    timerMyriabit = setInterval(() => {
                        that.myriabit --
                        if (num == that.myriabit) {
                            clearInterval(timerMyriabit)
                        }
                    }, 100);
                }
            },
            motionKilobit: function (num) {
                let that = this
                let timerKilobit
                if (num > that.kilobit) {
                    timerKilobit = setInterval(() => {
                        that.kilobit ++
                        if (num == that.kilobit) {
                            clearInterval(timerKilobit)
                        }
                    }, 100);
                } else if (num < that.kilobit){
                    timerKilobit = setInterval(() => {
                        that.kilobit --
                        if (num == that.kilobit) {
                            clearInterval(timerKilobit)
                        }
                    }, 100);
                }
            },
            motionHundreds: function (num) {
                let that = this
                let timerHundreds
                if (num > that.hundreds) {
                    timerHundreds = setInterval(() => {
                        that.hundreds ++
                        if (num == that.hundreds) {
                            clearInterval(timerHundreds)
                        }
                    }, 100);
                } else if (num < that.hundreds){
                    timerHundreds = setInterval(() => {
                        that.hundreds --
                        if (num == that.hundreds) {
                            clearInterval(timerHundreds)
                        }
                    }, 100);
                }
            },
            motionDecade: function (num) {
                let that = this
                let timerDecade
                if (num > that.decade) {
                    timerDecade = setInterval(() => {
                        that.decade ++
                        if (num == that.decade) {
                            clearInterval(timerDecade)
                        }
                    }, 100);
                } else if (num < that.decade){
                    timerDecade = setInterval(() => {
                        that.decade --
                        if (num == that.decade) {
                            clearInterval(timerDecade)
                        }
                    }, 100);
                }
            },
            motionUnit: function (num) {
                let that = this
                let timerUnit
                if (num > that.unit) {
                    timerUnit = setInterval(() => {
                        that.unit ++
                        if (num == that.unit) {
                            clearInterval(timerUnit)
                        }
                    }, 100);
                } else if (num < that.unit){
                    timerUnit = setInterval(() => {
                        that.unit --
                        if (num == that.unit) {
                            clearInterval(timerUnit)
                        }
                    }, 100);
                }
            }
        }
    }
</script>

<style>
    @font-face { 
        font-family: DINAlternateBold; /*这里是说明调用来的字体名字*/ 
        src: url(http://shared.youdao.com/dict/market/recite-vocabulary/fonts/DINAlternateBold.ttf); /*这里是字体文件路径*/ 
    }
    #tab {
        width: 6.42rem;
        height: 1.8rem;
        background-image: url(http://shared.youdao.com/dict/market/recite-vocabulary/img/page2_bg.png);
        background-size: 100% 100%;
        overflow: hidden;
        margin: 0.28rem auto 0.56rem;
    }
    .all_count, .right, .vocabulary, .wrong, .not_know {
        float: left;
    }
    #tab span {
        width: 100%;
        height: 0.37rem;
        font-size: 0.26rem;
        font-family: DINAlternateBold;
        color: rgba(144,148,158,1);
        line-height: 0.37rem;
        display: block;
        margin: 0;
    }
    #tab p {
        margin: 0;
        height: 0.57rem;
        font-size: 0.57rem;
        font-family: DINAlternateBold;
        color: rgba(255,255,255,1);
        line-height: 0.57rem;
        display: block;
        overflow: hidden;
    }
    #tab .desc {
        margin: 0.47rem 0 0 0;
    }
    #tab .num {
        width: 100%;
        height: 0.48rem;
        font-size: 0.38rem;
        font-family: DINAlternateBold;
        color:rgba(144,148,158,1);
        line-height: 0.43rem;
        text-align: center;
    }
    .all_count {
        width: 0.54rem;
        margin-left: 0.65rem;
    }
    #tab .right {
        width: 0.54rem;
        margin: 0 0.4rem 0 0.3rem;
    }
    .vocabulary {
        width: 1.55rem;
    }
    #tab .vocabulary .desc {
        width: 100%;
        height: 0.33rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular;
        color: rgba(255,255,255,1);
        line-height: 0.33rem;
    }
    #tab  .vocabulary .motion p {
        width: 100%;
        font-size: 0.48rem;
    }
    #tab .wrong {
        width: 0.54rem;
        margin-left: 0.4rem;
    }
    .not_know {
        width: 0.81rem;
        margin-left: 0.3rem;
    }
    .motion {
        margin: 0;
        width: 100%;
        height: 0.57rem;
        font-size: 0.57rem;
        font-family: DINAlternate-Bold;
        color: rgba(255,255,255,1);
        line-height: 0.57rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tab.vue